import React, { memo, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  MenuItem,
  InputAdornment,
  Button,
  Grid,
} from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  ValidatorForm,
  TextValidator,
  SelectValidator,
} from "react-material-ui-form-validator";

import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { startAlerta } from "../../../../actions/ui/alertas";
import { CboNacionalidades } from "../../../cbos/CboNacionalidades";
import { CboLocalidades } from "../../../cbos/CboLocalidades";
import { CboProvincias } from "../../../cbos/CboProvincias";
import { CboSeccionales } from "../../../cbos/CboSeccionales";
import { useForm } from "../../../../hooks/useForm";
import { ESTADOS_CIVILES, SEXO, TIPO_DOCUMENTO } from "../../../../utils/constants";
import { changeStepper } from "../../../../actions/preAfiliado/stepper";
import { CboCategoriaWeb } from "./CboCategoriaWeb";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  botonera: {
    marginTop: 25,
  },
  NroAfi: {
    fontSize: 15,
  },
  hideButton: {
    display: "none",
  },
  fab: {
    position: "relative",
    top: theme.spacing(2),
    left: theme.spacing(15),
  },
}));

const initialValuesAfiliado = (formValues, afiliadoEncontrado) => ({
  apellido_nombre: formValues?.apellido_nombre || afiliadoEncontrado?.apellido_y_nombre || "",
  sexo: formValues?.sexo || afiliadoEncontrado?.sexo || "",
  idTipoDoc: formValues?.idTipoDoc || afiliadoEncontrado?.id_tipo_documento || "",
  nro_documento: formValues?.nro_documento || afiliadoEncontrado?.nro_doc || "",
  fecha_nacimiento: formValues?.fecha_nacimiento || afiliadoEncontrado?.fecha_nacimiento || "",
  id_estado_civil: formValues?.id_estado_civil || afiliadoEncontrado?.id_estado_civil || "",
  id_nacionalidad: formValues?.id_nacionalidad || afiliadoEncontrado?.id_nacionalidad || "",
  cuil: formValues?.cuil || afiliadoEncontrado?.cuil || "",
  id_sit_revista: formValues?.id_sit_revista || afiliadoEncontrado?.id_sit_revista || "",
  rnos: formValues?.rnos || afiliadoEncontrado?.rnos || "",
  afiliadoUtedyc: formValues?.afiliadoUtedyc || afiliadoEncontrado?.afiliadoUtedyc || "",
  domiciliosAfiliados: {
    calle: formValues?.domiciliosAfiliados?.calle || afiliadoEncontrado?.domiciliosAfiliados?.calle || "",
    nro: formValues?.domiciliosAfiliados?.nro || afiliadoEncontrado?.domiciliosAfiliados?.nro || "",
    piso: formValues?.domiciliosAfiliados?.piso || afiliadoEncontrado?.domiciliosAfiliados?.piso || "",
    depto: formValues?.domiciliosAfiliados?.depto || afiliadoEncontrado?.domiciliosAfiliados?.depto || "",
    torre: formValues?.domiciliosAfiliados?.torre || afiliadoEncontrado?.domiciliosAfiliados?.torre || "",
    circ: formValues?.domiciliosAfiliados?.circ || afiliadoEncontrado?.domiciliosAfiliados?.circ || "",
    manzana: formValues?.domiciliosAfiliados?.manzana || afiliadoEncontrado?.domiciliosAfiliados?.manzana || "",
    telefono: formValues?.domiciliosAfiliados?.telefono || afiliadoEncontrado?.domiciliosAfiliados?.telefono || "",
    telefono_laboral: formValues?.domiciliosAfiliados?.telefono_laboral || afiliadoEncontrado?.domiciliosAfiliados?.telefono_laboral || "",
    celular: formValues?.domiciliosAfiliados?.celular || afiliadoEncontrado?.domiciliosAfiliados?.celular || "",
    codigo_postal: formValues?.domiciliosAfiliados?.codigo_postal || afiliadoEncontrado?.domiciliosAfiliados?.codigo_postal || "",
    mail: formValues?.domiciliosAfiliados?.mail || afiliadoEncontrado?.domiciliosAfiliados?.mail || "",
    id_localidad: formValues?.domiciliosAfiliados?.id_localidad || afiliadoEncontrado?.domiciliosAfiliados?.id_localidad || "",
    id_provincia: formValues?.domiciliosAfiliados?.id_provincia || afiliadoEncontrado?.domiciliosAfiliados?.id_provincia || "",
    id_seccional: formValues?.domiciliosAfiliados?.id_seccional || afiliadoEncontrado?.domiciliosAfiliados?.id_seccional || "",
  }
})



export const PanelDatosWeb = memo((props) => {
  const classes = useStyles();
  moment.locale("es");
  const dispatch = useDispatch();

  const { afiliado } = useSelector(
    (state) => state.afiliacion
  );
  const { afiliadoEncontrado } = useSelector((state) => state.preinscripto);
  const { step } = useSelector((state) => state.stepper);
  const { items } = useSelector((state) => state.localidades);

  const tabIngreso = props.idPanel === "idTabIngreso";
  const activeId = useRef(afiliado?.id_afiliado);

  const [
    formValues,
    handleInputChange,
    reset,
    setearValor,
    setearValor2,
    setearValorDomicilio,
    setearValorDomicilio2,
    ,
    setearVariosValores,
  ] = useForm(initialValuesAfiliado(props?.form?.formValues, afiliadoEncontrado));

  const {
    apellido_nombre,
    sexo,
    idTipoDoc,
    nro_documento,
    fecha_nacimiento,
    id_estado_civil,
    id_nacionalidad,
    cuil,
    id_sit_revista,
    domiciliosAfiliados: {
      calle,
      nro,
      piso,
      depto,
      torre,
      circ,
      manzana,
      telefono,
      telefono_laboral,
      celular,
      codigo_postal,
      mail,
      id_localidad,
      id_provincia,
      id_seccional,
    },
    afiliadoUtedyc
  } = formValues;

  const [stateFechaNacimiento, setStateFechaNacimiento] = useState(fecha_nacimiento);


  const handleLocalidadChange = (e) => {
    if (items?.length > 0) {
      const localidad = items.find(
        (loc) => parseInt(loc?.id_localidad) === parseInt(e.target.value)
      );
      setearValorDomicilio2(
        "id_provincia",
        localidad.id_provincia,
        "id_localidad",
        localidad.id_localidad,
        "id_seccional",
        localidad.id_seccional
      );
    }
  };


  const handleCPChange = (e) => {
    let reg = new RegExp("^[0-9]+$");
    const cp = e.target.value;
    if (cp === "" || reg.test(cp)) {
      const listaFiltrada = items.filter(loc => cp?.toString().length === 4 && parseInt(loc.codigo_postal) === parseInt(cp));
      if (listaFiltrada?.length > 0) {
        const localidad = listaFiltrada[0];
        setearVariosValores({
          domiciliosAfiliados: {
            ...formValues.domiciliosAfiliados,
            codigo_postal: cp,
            id_provincia: localidad?.id_provincia,
            id_localidad: localidad?.id_localidad,
            id_seccional: localidad?.id_seccional
          }
        });
      } else {
        setearVariosValores({
          domiciliosAfiliados: {
            ...formValues.domiciliosAfiliados,
            codigo_postal: cp,
            id_provincia: "",
            id_localidad: "",
            id_seccional: ""
          }
        });
      }
    }
  };

  const handleInputDomicilio = (e) => {
    setearValorDomicilio(e.target.name, e.target.value);
  };

  const handleChangeValid = (e) => {
    if (e.target.value === TIPO_DOCUMENTO.RN) {
      setearValor2(
        "fecha_fin_cobertura",
        moment(fecha_nacimiento).add(1, "M"),
        "idTipoDoc",
        e.target.value
      );
    } else {
      setearValor2(
        "fecha_fin_cobertura",
        null,
        "idTipoDoc",
        e.target.value
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.form.setFormValues({ ...formValues })
    dispatch(changeStepper(step + 1));
  };

  const [edad, setEdad] = useState(
    moment().diff(moment(fecha_nacimiento), "years", false)
  );


  useEffect(() => {
    if (afiliado && afiliado.id_afiliado !== activeId.current) {
      reset(afiliado);
      setEdad(
        moment().diff(moment(afiliado?.fecha_nacimiento), "years", false)
      );
      activeId.current = afiliado.id_afiliado;
    }
  }, [afiliado, reset]);


  //VALIDACIONES
  const emailValidators = ["required", "isEmail"];

  const emailErrorMessage = ["El Email es requerido", "Email invalido"];

  const calleValidator = ["required"];

  const calleErrorMessage = ["La calle es requerida"];

  const validadoresTelefono = ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

  const errorMessageTelefono = [
    "El telefono es requerido",
    "Solo numeros",
    "Verifique su telefono",
    "Verifique su telefono",
  ];

  const validadoresCelular = ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

  const errorMessageCelular = [
    "El celular es requerido",
    "Solo numeros",
    "Verifique su celular",
    "Verifique su celular",
  ];


  const onChangeDNIHandler = (event) => {
    if (!tabIngreso) {
      if (
        event.target.value.trim().length === 7 &&
        cuil.toString().trim().length === 11
      ) {
        setearValor("cuil", "");
      }
    }
  };

  const onChangeCuildHandler = (event) => {
    if (!tabIngreso) {
      if (
        event.target.value.trim().length === 10 &&
        nro_documento.toString().trim().length === 8
      ) {
        setearValor("nro_documento", "");
      }
    }
  };

  return (
    <>
      <ValidatorForm onSubmit={handleSubmit}>
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <TextValidator
                margin="normal"
                fullWidth
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Apellido y Nombre"
                name="apellido_nombre"
                disabled={false}
                value={apellido_nombre || ""}
                autoComplete="off"
                validators={["required"]}
                errorMessages={["Este campo es obligatorio"]}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={1}>
              <SelectValidator
                value={sexo || ""}
                disabled={false}
                onChange={(e) => {
                  if (e.target.value === SEXO.NO_INFORMADO) dispatch(startAlerta("El sexo NO INFORMADO no se encuentra permitido", "error", "Error"))
                  else setearValor("sexo", e.target.value)
                }
                }
                label="Sexo"
                name="sexo"
                validators={["required"]}
                errorMessages={["El sexo es requerido"]}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  shrink: true,
                }}
                fullWidth={true}
              >
                <MenuItem value="">
                  <em>Seleccione</em>
                </MenuItem>
                <MenuItem value={SEXO.MASCULINO}>M</MenuItem>
                <MenuItem value={SEXO.FEMENINO}>F</MenuItem>
                <MenuItem value={SEXO.NO_INFORMADO}>N</MenuItem>
                <MenuItem value={SEXO.NO_BINARIO}>X</MenuItem>
              </SelectValidator>
            </Grid>
            <Grid item xs={1}>
              <SelectValidator
                value={idTipoDoc || ""}
                disabled={false}
                label="Tip.Doc"
                name="idTipoDoc"
                validators={["required"]}
                errorMessages={["Este campo es obligatorio"]}
                margin="normal"
                fullWidth={true}
                onChange={handleChangeValid}
              >
                <MenuItem value="">
                  <em>Seleccione</em>
                </MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.DNI}>DNI</MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.LIBRETA_ENROLAMIENTO}>
                  LE
                </MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.LIBRETA_CIVICA}>LC</MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.PASAPORTE}>PAS</MenuItem>
                <MenuItem value={TIPO_DOCUMENTO.NI}>NI</MenuItem>
              </SelectValidator>
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                margin="normal"
                fullWidth
                label="Nro. Doc."
                name="nro_documento"
                value={nro_documento || ""}
                disabled={true}
                autoComplete="off"
                onChange={(e) => {
                  handleInputChange(e);
                  onChangeDNIHandler(e);
                }}
                validators={["required", "isNumber", "maxNumber:99999999"]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "Solo numeros",
                  "Verifique su dni",
                ]}
              />
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                margin="normal"
                fullWidth
                label="CUIL"
                name="cuil"
                value={cuil || ""}
                autoComplete="off"
                disabled={true}
                onChange={(e) => {
                  handleInputChange(e);
                  onChangeCuildHandler(e);
                }}
                validators={[
                  "required",
                  "isNumber",
                  "maxNumber:99999999999",
                  "minNumber:9999999999",
                ]}
                errorMessages={[
                  "Este campo es obligatorio",
                  "Solo numeros",
                  "Verifique su cuil",
                  "Verifique su cuil",
                ]}
              />
            </Grid>
            <Grid item xs={2}>
              <SelectValidator
                value={id_estado_civil || ""}
                disabled={false}
                onChange={(e) => {
                  handleInputChange(e);
                }}
                label="Est.Civil"
                name="id_estado_civil"
                validators={["required"]}
                errorMessages={["El estado es requerido"]}
                fullWidth={true}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="">
                  <em>Seleccione</em>
                </MenuItem>
                <MenuItem value={ESTADOS_CIVILES.CASADO}>CASADO/A</MenuItem>
                <MenuItem value={ESTADOS_CIVILES.SOLTERO}>SOLTERO/A</MenuItem>
                <MenuItem value={ESTADOS_CIVILES.SEPARADO}>SEPARADO/A</MenuItem>
                <MenuItem value={ESTADOS_CIVILES.DIVORCIADO}>
                  DIVORCIADO/A
                </MenuItem>
                <MenuItem value={ESTADOS_CIVILES.VIUDO}>VIUDO/A</MenuItem>
                <MenuItem value={ESTADOS_CIVILES.CONCUBINO}>
                  CONCUBINO/A
                </MenuItem>
                <MenuItem value={ESTADOS_CIVILES.OTRO}>OTRO</MenuItem>
              </SelectValidator>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="dialogFecha_nacimiento"
                  label="Fec. Nac."
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  required={true}
                  maxDate={new Date()} //maxDate
                  minDate={moment().subtract("year", 200)}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  disabled={false}
                  value={stateFechaNacimiento}
                  minDateMessage={`La fecha no debe ser anterior a la fecha mínima`}
                  onChange={(date) => {
                    setStateFechaNacimiento(date)
                    setearValor("fecha_nacimiento", date);
                    setEdad(moment().diff(moment(date), "years", false));
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  validators={["isValidDate"]}
                  errorMessages={["La fecha ingresada no es valida"]}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                fullWidth
                label="Edad"
                value={`${edad || ""} Años`}
                autoComplete="off"
                disabled={true}
              />
            </Grid>
            <Grid item xs={2}>
              <CboNacionalidades
                manejadorInputChange={handleInputChange}
                valor={id_nacionalidad}
                fromBandejaFamiliar={props.fromBandejaFamiliar}
                fromBandeja={props.fromBandeja}
                idPanel={props.idPanel}
                disabled={false}
              />
            </Grid>
            <Grid item xs={3}>
              <TextValidator
                margin="normal"
                value={mail || ""}
                disabled={false}
                onChange={handleInputDomicilio}
                label="Email"
                name="mail"
                autoComplete="off"
                fullWidth
                validators={emailValidators}
                errorMessages={emailErrorMessage}
              />
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                fullWidth
                margin="normal"
                value={telefono || ""}
                onChange={handleInputDomicilio}
                label="Teléfono(10 dígitos sin 0)"
                disabled={false}
                name="telefono"
                autoComplete="off"
                maxLength="10"
                validators={validadoresTelefono}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">0</InputAdornment>
                  ),
                }}
                errorMessages={errorMessageTelefono}
              />
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                fullWidth
                margin="normal"
                value={celular || ""}
                onChange={handleInputDomicilio}
                label="Celular(10 dígitos sin 0 ni 15)"
                disabled={false}
                name="celular"
                maxLength="10"
                autoComplete="off"
                validators={validadoresCelular}
                errorMessages={errorMessageCelular}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextValidator
                margin="normal"
                value={calle || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Calle"
                name="calle"
                disabled={false}
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
                validators={calleValidator}
                errorMessages={calleErrorMessage}
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={codigo_postal || ""}
                onChange={handleCPChange}
                label="Cod. Postal"
                disabled={false}
                name="codigo_postal"
                inputProps={{ maxLength: 4 }}
                autoComplete="off"
                validators={["required"]}
                errorMessages={["El codigo postal es requerido"]}
              />
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                margin="normal"
                value={nro || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Numero"
                name="nro"
                disabled={false}
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={piso || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Piso"
                name="piso"
                disabled={false}
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                margin="normal"
                value={depto || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Depto."
                name="depto"
                disabled={false}
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={torre || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Torre"
                name="torre"
                disabled={false}
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={circ || ""}
                inputProps={{ style: { textTransform: "uppercase" } }}
                label="Circ"
                name="circ"
                disabled={false}
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
            <Grid item xs={1}>
              <TextValidator
                margin="normal"
                value={manzana || ""}
                inputProps={{ maxLength: 5, style: { textTransform: "uppercase" } }}
                label="Manzana"
                name="manzana"
                disabled={false}
                onChange={handleInputDomicilio}
                autoComplete="off"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <CboLocalidades
                manejadorInputChange={(e) => {
                  handleInputDomicilio(e);
                  handleLocalidadChange(e);
                }}
                name="id_localidad"
                fromBandejaFamiliar={false}
                fromBandeja={false}
                disabled={false}
                valor={id_localidad}
                cp={codigo_postal}
                idPanel={props.idPanel}
              />
            </Grid>
            <Grid item xs={2}>
              <CboProvincias
                manejadorInputChange={handleInputDomicilio}
                valor={id_provincia}
                name="id_provincia"
                idPanel={props.idPanel}
                esReactivacion={props.esReactivacion}
              />
            </Grid>
            <Grid item xs={2}>
              <CboSeccionales
                manejadorInputChange={handleInputDomicilio}
                valor={id_seccional}
                name="id_seccional"
                disabled
                idPanel={props.idPanel}
                esReactivacion={props.esReactivacion}
              />
            </Grid>
            <Grid item xs={2}>
              <CboCategoriaWeb
                manejadorInputChange={handleInputChange}
                fromBandejaFamiliar={false}
                fromBandeja={false}
                valor={id_sit_revista}
                parentesco={""}
                idPanel={props.idPanel}
                reactivacion={false}
              />
            </Grid>
            <Grid item xs={1}>
              <SelectValidator
                value={afiliadoUtedyc || ""}
                onChange={(e) => {
                  handleInputChange(e);
                }}
                label="Afiliado Utedyc"
                name="afiliadoUtedyc"
                validators={["required"]}
                errorMessages={["El estado es requerido"]}
                fullWidth={true}
                margin="normal"
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="">
                  <em>Seleccione</em>
                </MenuItem>
                <MenuItem value={"SI"}>SI</MenuItem>
                <MenuItem value={"NO"}>NO</MenuItem>
              </SelectValidator>
            </Grid>
            <Grid item xs={2}>
              <TextValidator
                fullWidth
                margin="normal"
                value={telefono_laboral || ""}
                onChange={handleInputDomicilio}
                label="Teléfono Laboral(10 dígitos sin 0)"
                disabled={false}
                name="telefono_laboral"
                autoComplete="off"
                maxLength="10"
                validators={["isNumber", "maxNumber:9999999999", "minNumber:999999999"]}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">0</InputAdornment>
                  ),
                }}
                errorMessages={[
                  "Solo numeros",
                  "Verifique su telefono",
                  "Verifique su telefono",
                ]}
              />
            </Grid>
          </Grid>
          <Button id="btnsubmit" className={classes.hideButton} type="submit">
            Submit
          </Button>
        </div>
      </ValidatorForm>
    </>
  );
});
